import React, { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { Row, Col, Form, InputGroup, Offcanvas } from "react-bootstrap";
import { TwitterPicker } from "react-color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useMyGlobal } from "./GlobalData";
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

const ProductFilter = ({
    filter,
    setFilter,

    sortConfig,
    setSortConfig,

    colorList,
    brandList,
    sizeList
}) => {
    const [prodName, setProdName] = useState('')
    const [priceMin, setPriceMin] = useState(0)
    const [priceMax, setPriceMax] = useState(5000000)
    const [mainColors, setMainColors] = useState([])
    const [showPicker, setShowPicker] = useState(false)
    const [selColor, setSelColor] = useState('')
    const idCustomer = (localStorage.getItem('loginData') !== null) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const { token } = useMyGlobal()
    const [canvasShow, setCanvasShow] = useState(false)
    const [brand, setBrand] = useState(filter.brand || '')
    const [size, setSize] = useState(filter.size || '')

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = {
        color: {
            width: '36px',
            height: '16px',
            borderRadius: '2px',
            background: `${selColor}`,
        },
        swatch: {
            padding: '8.5px',
            background: '#fff',
            borderRadius: '3px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.2)',
            display: 'inline-flex',
            cursor: 'pointer',
        },
        popover: {
            position: 'absolute',
            zIndex: '2',
        },
        cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        },
    }

    const handleClick = (e) => {
        e.preventDefault()
        setShowPicker(!showPicker)
    }

    const handleClose = () => (setShowPicker(false))

    const handleChange = (color) => (setSelColor(color.hex))

    const handleBrandChange = (e) => setBrand(e.target.value)
    const handleSizeChange = (e) => setSize(e.target.value)

   const handleClear = () => {
        setBrand('')
        setSize('')
        setProdName('')
        setSelColor('')
        setPriceMin(0)
        setPriceMax(5000000)

        setFilter({
            brand: '',
            size: '',
            color: '',
            priceMin: '',
            priceMax: ''
        })

        setSortConfig({
            sort: '',
            onSale: false
        })
    }

    const colorOpt = (colors) => {
        let arr = []
        colors.map(i => (arr.indexOf(i.color_main) === -1) ? arr.push(i.color_main) : false)
        setMainColors(arr)
    }

    const handleCloseCanvas = () => setCanvasShow(false)
    const handleClickCanvas = () => setCanvasShow(!canvasShow)

    useEffect(() => {
        colorOpt(colorList)
    }, [colorList])

   const toggleSort = (key, value = null) => {

        if (key === 'recommended') {

            setSortConfig({
                sort: '',
                onSale: false
            })

            return
        }

        if (key === 'on_sale') {
            
            const newValue = !sortConfig.onSale

            setSortConfig(prev => ({
                ...prev,
                onSale: newValue
            }))

            return
        }

        if (key === 'price') {
/*
            setSortConfig({
                sort: value === 'asc'
                    ? 'price_low'
                    : 'price_high',

                onSale: false
            })
*/
            setSortConfig(prev => ({
                ...prev,
                sort: value === 'asc'
                    ? 'price_low'
                    : 'price_high'
            }))
        }
    }

    const renderForm = () => (
        <>
        <div>
            <h3 className="mb-3 text-bold">Sort</h3>
            <Row>
                <Col xl={12} className="mb-2">
                    <Button
                        content="New Arrival"
                        className={`sort-button active`}
                        color={`${!sortConfig.sort && !sortConfig.onSale ? 'orange' : ''}`}
                        onClick={() => toggleSort('recommended')}
                    />
                </Col>
                
                <Col className="col-12 mb-2">
                    <Button
                        content="On Sale"
                        className={`sort-button active`}
                        color={`${sortConfig.onSale ? 'orange' : ''}`}
                        onClick={() => toggleSort('on_sale')}
                    />
                </Col>

                <Col className="col-12">
                    <Form.Select
                        value={
                            sortConfig.sort === 'price_low'
                                ? 'asc'
                                : sortConfig.sort === 'price_high'
                                ? 'desc'
                                : ''
                        }
                        onChange={(e) => toggleSort('price', e.target.value)}
                        className={`sort-dropdown ${sortConfig.sort ? 'active' : ''}`}
                    >
                        <option value="" disabled>Sort by price...</option>
                        <option value="asc">Price: Low to High</option>
                        <option value="desc">Price: High to Low</option>
                    </Form.Select>
                </Col>
                
            </Row>
        </div>
        
        <hr class="hr" style={{margin: "2rem 0px 2rem 0px"}}/>

        <Form onSubmit={(e) => {
           e.preventDefault()

            setFilter(prev => ({
                ...prev,
                brand,
                size,
                color: selColor,
                priceMin,
                priceMax
            }))

            if (isMobile) {
                setCanvasShow(false)
            }
        }}>
            <h3 className="mb-3 text-bold">Filter</h3>
            <Row>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Brand</Form.Label>
                    <Form.Select value={brand} onChange={handleBrandChange}>
                        <option value="">Select...</option>
                        {
                            brandList.map((item, i) => {
                                const words = item.category_name.split(' ')
                                const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

                                return (
                                    <option key={i} value={item.id_category}>{capitalizedWords.join(' ')}</option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Size</Form.Label>
                    <Form.Select value={size} onChange={handleSizeChange}>
                        <option value="">Select...</option>
                        {
                            sizeList.map((item, i) => (
                                <option key={i} value={item}>{item}</option>
                            ))
                        }
                    </Form.Select>
                </Col>
                <Col xl={12} className="mb-3">
                    <div className="mb-2 fw-bold">Color</div>
                    <InputGroup>
                        <div style={styles.swatch} >
                            <div style={styles.color} onClick={(e) => handleClick(e)} />
                            {
                                (selColor !== '') ?
                                    <FontAwesomeIcon icon={faClose} className="ms-2" onClick={() => setSelColor('')} />
                                    : <></>
                            }
                        </div>

                    </InputGroup>
                    {showPicker ?
                        <div style={styles.popover}>
                            <div style={styles.cover} onClick={handleClose} />
                            <TwitterPicker colors={mainColors} color={selColor} onChange={handleChange} onChangeComplete={handleClose} />
                        </div> : null}
                </Col>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Price Range (Rp)</Form.Label>
                    <div className="mb-2">
                        <div className="d-flex justify-content-between">
                            <span>Rp {Number(priceMin).toLocaleString()}</span>
                            <span>Rp {Number(priceMax).toLocaleString()} ++</span>
                        </div>
                    </div>

                    <Slider
                        range
                        min={0}
                        max={5000000}
                        step={50000}
                        value={[priceMin || 0, priceMax || 5000000]}
                        onChange={(value) => {
                            setPriceMin(value[0])
                            setPriceMax(value[1])
                        }}
                        handleStyle={[{ borderColor: 'orange' }, { borderColor: 'orange' }]}
                        trackStyle={[{ backgroundColor: 'orange' }]}
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-end align-self-end mb-3 mt-3">
                    <Button.Group floated="Left" fluid>
                        <Button content="Apply" icon="filter" type="submit" color="orange" />
                        <Button content="Clear" type="reset" icon="retweet" onClick={() => handleClear()} color="black" />
                    </Button.Group>
                </Col>
            </Row>
        </Form>
        </>
    )

    return (
        <section>

            {isMobile ? (
                <>
                    <div className="row" style={{justifyContent: 'end'}}>
                        <div className="col-6">
                            <Button
                                className="w-100"
                                content="Sort & Filter"
                                icon="filter"
                                onClick={handleClickCanvas}
                                basic color="black" 
                                style={{paddingLeft: '0', paddingRight: '0'}}
                            />
                        </div>
                    </div>

                    <Offcanvas show={canvasShow} onHide={handleCloseCanvas}>
                        <Offcanvas.Header>
                            <Offcanvas.Title></Offcanvas.Title>
                            <Icon name="close" onClick={handleClickCanvas} size="large" style={{cursor:'pointer'}}/>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            {renderForm()}
                        </Offcanvas.Body>
                    </Offcanvas>
                </>
            ) : (
                <div className="p-3 border rounded bg-white d-flex">
                    <div className="w-100 text-start" style={{ maxWidth: "320px"}}>
                        {renderForm()}
                    </div>
                </div>
            )}

        </section>
    )
}

export default ProductFilter;